import type { CSSProperties } from 'react';
import React from 'react';

export type FilterSliderInputProps = {
  id: string;
  value: number;
  label?: string;
  unit?: string;
  min: number;
  max: number;
  step?: number;
  reverse?: boolean;
  onChange: (value: number) => void;
  validate: (value: string) => number;
  hasTooltip?: boolean;
};

interface SliderThumbProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: { style: CSSProperties }; // options from react-range, no type exported
  labelledById: string;
  isDragging: boolean;
  index: number;
  value?: number;
  unit?: string;
}

export const SliderThumb: React.FC<SliderThumbProps> = ({ options, labelledById, isDragging, index }) => (
  <div
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    {...options}
    aria-labelledby={labelledById}
    style={{
      ...options.style,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div
      data-testid={`slider-handle-${index}`}
      style={{
        ...options.style,
        height: '18px',
        width: '18px',
        backgroundColor: 'white',
        borderRadius: '100%',
        border: '1px solid #626262',
        outline: 'none',
        // ignore isDragging in coverage, as it's library functionality
        boxShadow: /* istanbul ignore next */ isDragging ? '0 0 8px #2C74A9' : 'none',
      }}
    />
  </div>
);
